import { makeStyles, Theme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import React, { Fragment } from "react"
import Calendar from "Components/Calendar"

export default function CenteredTabs() {

    return (
        <Fragment>
            <Calendar channelName={'果壳视频'} />

            <Typography component="div">
                <pre style={{whiteSpace: 'pre-line'}}>
                    备注：<br />
                    1、B站更新1-2次/周，商务排期2次/月；<br />
                    2、快手、视频号更新3-4次/周，商务排期2次/周；<br />
                    3、果壳视频频博、秒拍暂无次数限制。<br />
                </pre>
            </Typography>
            <div id="board_input_modal" />
        </Fragment>
    )
}
